<button
  *ngIf="getUrlAndParams || getCsvData"
  nz-tooltip
  [nzTooltipTitle]="buttonTooltip"
  nz-button
  [disabled]="disabled || isLoading"
  [nzLoading]="isLoading"
  nzSize="default"
  (click)="download()"
  nzType="link"
>
  <span class="inline-flex items-center space-x-8">
    <twaice-fe-svg-icon nz-icon name="download" source="tabler" width="16px" height="16px" />
    <span>Download</span>
  </span>
</button>
